import script from "./method.vue?vue&type=script&setup=true&lang=js"
export * from "./method.vue?vue&type=script&setup=true&lang=js"

import "./method.vue?vue&type=style&index=0&id=dfd1005a&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dfd1005a"]])

export default __exports__